import { Stack, Box, Typography, Divider } from "@mui/material"
import mgFlagLogo from '../../assets/Quilted Flag - Bold Zoom Tilt.png'
import mgScriptLogo from '../../assets/Stacked Cursive.png'
import { useTBContext } from "../Contexts/useTBStates";

interface SidebarBrandingBlockProps {
    factor: number;
}

export const SidebarBrandingBlock = ({ factor }: SidebarBrandingBlockProps) => {
    const scale = factor < 1 ? factor : 1;
    return (
            <Stack direction={'row'} spacing={1} alignItems={'center'} justifyContent={'flex-start'} paddingLeft={2}
                sx={{ height: 60 * scale, width: '100%', backgroundColor: 'sepia.background', borderBottom: '1px solid sepia.extraLight' }}>
                <Stack direction={'row'} spacing={1} alignItems={'flex-end'} justifyContent={'flex-end'}>
                    {/* <img
                        src={mgFlagLogo}
                        alt="Moment Golf"
                        style={{ height: 52 * scale, width: 'auto', flexShrink: 0 }}
                    /> */}
                    <img
                        src={mgScriptLogo}
                        alt="Moment Golf"
                        style={{ height: 50 * scale, width: 'auto', flexShrink: 0 }}
                    />
                </Stack>
            </Stack>
    );
};

interface SidebarUserInfoProps {
    factor: number;
    onAvatarClick: () => void;
    anchorId: string;
}

export const SidebarUserInfo = ({ factor, onAvatarClick, anchorId }: SidebarUserInfoProps) => {
    const scale = factor < 1 ? factor : 1;
    const { appTheme } = useTBContext();

    return (
        <Box sx={{ width: '100%', flexShrink: 0 }}>
            <Divider sx={{ borderColor: 'sepia.extraLight' }} />
            <Stack direction={'row'} spacing={1.5} alignItems={'center'}
                sx={{
                    padding: `${10 * scale}px ${16 * scale}px`,
                    cursor: 'pointer',
                    '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' }
                }}
                id={anchorId}
                onClick={onAvatarClick}
            >
                <Box
                    sx={{
                        width: 40 * scale,
                        height: 40 * scale,
                        borderRadius: '50%',
                        backgroundColor: 'sepia.extraLight',
                        border: `1px solid ${appTheme.palette.sepia?.main}`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                    }}
                >
                    <Typography
                        variant='subtitle2'
                        sx={{ fontWeight: 600, color: 'sepia.dark', fontSize: `${14 * scale}px` }}
                        id='sidebar-avatar-initials'
                    />
                </Box>
                <Stack direction={'column'} spacing={0} sx={{ overflow: 'hidden' }}>
                    <Typography
                        variant='caption'
                        sx={{ color: 'sepia.dark', fontSize: `${12 * scale}px`, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                        id='sidebar-user-email'
                    />
                    <Typography
                        variant='caption'
                        sx={{ color: 'sepia.main', fontSize: `${11 * scale}px` }}
                    >
                        My Account
                    </Typography>
                </Stack>
            </Stack>
        </Box>
    );
};
